<template>
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          NetAtmo
        </p>
      </header>
      <div class="card-content">
        <div class="content">
          <center>

            <div v-if="!statusThermostat.erreur">
              <ttbox-miniGauge v-if="statusThermostat.therm_measured_temperature" libelle="Température" unite="°C" :valeur="statusThermostat.therm_measured_temperature" :min="10" :max="40" ></ttbox-miniGauge>

              <!-- Consigne -->
              <div v-if="consigne && therm_setpoint_mode!=='off' && therm_setpoint_mode!=='hg' && therm_setpoint_mode!=='away'">
                <div class="has-text-centered">
                  <div>
                    <p class="heading">Consigne</p>
                    <p class="title">
                      {{consigne}}
                      <span v-if="statusThermostat.boiler_status" class="icon is-small has-text-info" style="font-size:1rem;">
                        <i class="fas fa-burn"></i>
                      </span>
                    </p>
                  </div>
                </div>
                <vue-slider v-model="consigne" :interval="consignePas" :min="consigneMin" :max="consigneMax" tooltip=none @change="consigneChange"></vue-slider>
                <div v-if="therm_setpoint_mode==='manual'">
                  <div  class="has-text-centered">
                    <div>
                      <p class="heading">Jusqu'à</p>
                      <p class="title">{{consigneDate | utcToTime}}</p>
                    </div>
                  </div>
                  <div>
                    <vue-slider v-model="consigneDate" :interval="consigneDatePas" :min="consigneDateMin" :max="consigneDateMax" tooltip=none></vue-slider>
                  </div>
                </div>
                <div class="buttons">
                  <a class="button is-outlined" @click="annuler" v-if="therm_setpoint_mode_init!=='manual' && therm_setpoint_mode==='manual'">
                    <span>Annuler</span>
                    <span class="icon is-small">
                      <i class="fas fa-times"></i>
                    </span>
                  </a>
                  <a class="button is-outlined" @click="supprimer" v-if="therm_setpoint_mode_init==='manual'">
                    <span>Supprimer</span>
                    <span class="icon is-small">
                      <i class="fas fa-times"></i>
                    </span>
                  </a>
                  <a class="button is-success" @click="ok" v-if="therm_setpoint_mode==='manual' || therm_setpoint_mode!==therm_setpoint_mode_init">
                    <span class="icon is-small">
                      <i class="fas fa-check"></i>
                    </span>
                    <span>Ok</span>
                  </a>
                </div>            
              </div>

                
              <div class="buttons has-addons" style="margin-top:20px;">
                <span v-if="therm_setpoint_mode!=='schedule' && therm_setpoint_mode!=='manual'" class="button" @click="allumer">On</span>
                <span v-if="therm_setpoint_mode==='schedule' || therm_setpoint_mode==='manual'" class="button is-success is-selected">On</span>
                <span v-if="therm_setpoint_mode!=='away'" class="button" @click="absenter">Abs</span>
                <span v-if="therm_setpoint_mode==='away'" class="button is-info is-selected">Abs</span>
                <span v-if="therm_setpoint_mode!=='hg'" class="button" @click="horsgel">Hg</span>
                <span v-if="therm_setpoint_mode==='hg'" class="button is-info is-selected">Hg</span>                
                <span v-if="therm_setpoint_mode!=='off'" class="button" @click="eteindre">Off</span>
                <span v-if="therm_setpoint_mode==='off'" class="button is-danger is-selected">Off</span>

              </div>
                

            </div>

            <div v-if="statusThermostat.erreur">
              <div class="notification is-danger">
                Erreur lors de la récupération des données NetAtmo
              </div>
            </div>

          </center>
        </div>
      </div>
      <footer class="card-footer">
        <p class="card-footer-item">
          <!-- Affichage qualité réception WiFi -->
          <ttbox-wifiSignal :signal="-statusThermostat.wifi_strength" />

          <!-- Affichage niveau batterie -->
          <span v-show="statusThermostat.battery_level>=batterie_pleine" class="icon has-text-success">
            <i class="fas fa-battery-full"></i>
          </span>
          <span v-show="statusThermostat.battery_level>=batterie_haute && statusThermostat.battery_level<batterie_pleine" class="icon has-text-success">
            <i class="fas fa-battery-three-quarters"></i>
          </span>
          <span v-show="statusThermostat.battery_level>=batterie_moyenne && statusThermostat.battery_level<batterie_haute" class="icon has-text-success">
            <i class="fas fa-battery-half"></i>
          </span>
          <span v-show="statusThermostat.battery_level<batterie_moyenne" class="icon has-text-danger">
            <i class="fas fa-battery-quarter"></i>
          </span>
        </p>
      </footer>
    </div>    
</template>

<script>
import MiniGauge from '../components/MiniGauge'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import DateFilter from '../filters/dateFilter'
import WiFiSignal from '../components/WiFiSignal'

export default {
  data() {
      return {
        consigneMin: 14,
        consigneMax: 22,
        consignePas: 0.5,
        consigne: null,
        consigneDateMin: null,
        consigneDateMax: null,
        consigneDate: null,
        consigneDatePas: 15*60*1000,
        therm_setpoint_mode: null,
        therm_setpoint_mode_init: null,
        batterie_pleine: 4100,
        batterie_haute: 3600,
        batterie_moyenne: 3300
      }
  },
  components: {
      'ttbox-miniGauge': MiniGauge,
      'vue-slider': VueSlider,
      'ttbox-wifiSignal': WiFiSignal
  },
  created() {
    var vm = this
    this.$store.dispatch('lireStatusThermostat')
    .then((status) => {
      vm.init(status)
    })
  },
  methods:{
    consigneChange() {
        this.therm_setpoint_mode = "manual"
    },
    init(status) {
      // Gestion de la consigne
      // Thermostat en marche manuelle ou planifiée
      if (status.therm_setpoint_mode === "manual" || status.therm_setpoint_mode === "schedule"){
        if (status.therm_setpoint_temperature < this.consigneMin) {
          this.consigne = this.consigneMin  
        } else {
          if (status.therm_setpoint_temperature > this.consigneMax) {
            this.consigne = this.consigneMax
          } else {
            this.consigne = status.therm_setpoint_temperature
          }
        }
      }

      // Gestion mode de fonctionnement
      this.therm_setpoint_mode = status.therm_setpoint_mode
      this.therm_setpoint_mode_init = status.therm_setpoint_mode

      // Gestion de la date
      // Arrondir au quart d'heure le plus proche
      var date = new Date(Date.now() + 15*60*1000)
      date.setMilliseconds(0)
      if (date.getMinutes() >= 0 && date.getMinutes() < 15) {
        date.setMinutes(0)
      }
      if (date.getMinutes() >= 15 && date.getMinutes() < 30) {
        date.setMinutes(15)
      }
      if (date.getMinutes() >= 30 && date.getMinutes() < 45) {
        date.setMinutes(30)
      }
      if (date.getMinutes() >= 45) {
        date.setMinutes(45)
      }
      this.consigneDateMin = date.getTime() // Date d'application de la consigne au moins 15 minutes arrondie à 15 minutes près
      this.consigneDateMax = date.getTime() + 24*60*60*1000 // Date d'application de la consigne jusqu'à 24 heures
      if (status.therm_setpoint_mode === "manual" && status.therm_setpoint_end_time !== 0) {
        this.consigneDate = status.therm_setpoint_end_time * 1000
      } else {
        this.consigneDate = date.getTime() + 3*60*60*1000 // Date d'application de la consigne jusqu'à 3 heures par défaut
      }
    },
    annuler(){
      // Annuler la saisie d'une consigne manuelle
      this.init(this.$store.state.statusThermostat)
    },
    supprimer(){
      this.appelNetatmo('supprimerConsigneManuelleThermostat', null)
    },
    allumer(){
      this.appelNetatmo('allumerThermostat', null)
    },
    eteindre(){
      this.appelNetatmo('eteindreThermostat', null)
    },
    absenter() {
      this.appelNetatmo('modeAbsenceThermostat', null)
    },
    horsgel() {
      this.appelNetatmo('modeHgThermostat', null)
    },
    ok(){
      // Valider la saisie d'une consigne manuelle
      let params = {
        temp: this.consigne,
        endtime: this.consigneDate / 1000
      }
      this.appelNetatmo('ecrireConsigneThermostat', params)
    },
    appelNetatmo(fonction, params) {
      // Fonction générique d'appel à NetAtmo avec gestion erreur sommaire ...
      var vm=this
      this.$store.dispatch(fonction, params)
      .then(() => vm.init(vm.$store.state.statusThermostat))
      .catch(() => {
        this.$notify({
          group: 'global',
          type: 'error',
          title: "NetAtmo",
          text: "Erreur lors de l'appel à NetAtmo (" + fonction + ")",
          duration: -1
        })
      });
    }
  },
  computed:{
      statusThermostat() {
      return this.$store.state.statusThermostat
      }
  },
  filters: {
    utcToTime: DateFilter.toTime
  }
}
</script>